// File: src/components/ProductFiltersWithList.tsx
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../state/store";
import CategorySidebar from "./CategorySidebar";
import ProductList from "./ProductList";
import StateProductList from "./StateProductList"; // new redux-based product list
import { useDispatch } from 'react-redux';
import { loadCategories } from "../../state/slices/categorySlice";

interface Props {
  categoryId?: string;
  searchQuery: string;
}

const ProductFiltersWithList: React.FC<Props> = ({ categoryId = "", searchQuery }) => {
  const categories = useSelector((state: RootState) => state.category.categories);
  const [selectedCats, setSelectedCats] = useState<string[]>([]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100000);
  const [inStock, setInStock] = useState(true);
  const [offset, setOffset] = useState(0);
    const dispatch = useDispatch<AppDispatch>();

  // initialize selectedCats from categoryId (on mount only)
    useEffect(() => {
      if (categoryId && categories.length > 0 && selectedCats.length === 0) {
        setSelectedCats([categoryId]);
      }
    }, [categoryId, categories, selectedCats.length]);


  useEffect(() => {
  if (categories.length === 0) {
    dispatch(loadCategories());
  }
}, [categories, dispatch]);

  const toggleCat = (id: string) =>
    setSelectedCats(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );

  const isMultiSelect = selectedCats.length > 1;
  const isNoCategorySelected = selectedCats.length === 0;
  const [showSidebar, setShowSidebar] = useState(false);


  return (
    <div className="product-filter-wrapper">
      {/* Mobile Filter Toggle */}
    <div className="mobile-filter-toggle-container">
      <button
        className="mobile-filter-toggle"
        onClick={() => setShowSidebar(prev => !prev)}
      >
        {showSidebar ? "Close Filters" : "☰ Filter"}
      </button>
    </div>

      {/* Sidebar (Redux) */}
      <CategorySidebar
      categories={categories}
      selected={selectedCats}
      onChange={toggleCat}
      className={showSidebar ? "open" : ""}
      onClose={() => setShowSidebar(false)}
    />



      {/* Filters Panel */}
      <div className="filter-panel">
        {/* Price Range */}
        <div className="filter-group">
          <label className="filter-label">💰 Price Range</label>
          <div className="filter-range-display">Rs. {minPrice} - Rs. {maxPrice}</div>
          <input
            type="range"
            min={0}
            max={100000}
            value={maxPrice}
            onChange={e => setMaxPrice(+e.target.value)}
            className="filter-range"
          />
        </div>

        {/* In-stock Toggle */}
        <div className="filter-group">
          <label className="filter-checkbox">
            <input
              type="checkbox"
              checked={inStock}
              onChange={e => setInStock(e.target.checked)}
            />
            <span>In-stock Only</span>
          </label>
        </div>


        {/* Product List: decide between API or Redux */}
        {isNoCategorySelected || isMultiSelect ? (
          <StateProductList
            categoryIds={isNoCategorySelected ? categories.map(c => c.id) : selectedCats}
            minPrice={minPrice}
            maxPrice={maxPrice}
            inStock={inStock}
            limit={10}
            offset={offset}
            searchQuery={searchQuery}
          />
        ) : (
          <ProductList
            categoryId={selectedCats[0]}
            minPrice={minPrice}
            maxPrice={maxPrice}
            inStock={inStock}
            limit={10}
            offset={offset}
            searchQuery={searchQuery}
          />
        )}
      </div>
    </div>
  );
};

export default ProductFiltersWithList;
